import * as React from "react";
import * as Popover from "@radix-ui/react-popover";
import { DayPicker } from "react-day-picker";
import { Calendar as CalendarIcon } from "lucide-react";
import { format } from "date-fns";
import "react-day-picker/style.css";

interface DatePickerProps {
  value?: Date;
  onChange: (date?: Date) => void;
  placeholder?: string;
  disabled?: any;
}

export default function DatePicker({
  value,
  onChange,
  placeholder = "Select Date",
  disabled,
}: DatePickerProps) {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <button
          type="button"
          className="w-full flex items-center justify-between border rounded-md px-3 py-2 text-left"
        >
          <span>
            {value ? format(value, "dd MMM yyyy") : placeholder}
          </span>
          <CalendarIcon size={18} />
        </button>
      </Popover.Trigger>

      <Popover.Portal>
        <Popover.Content
          sideOffset={5}
          className="bg-white border rounded-lg shadow-lg p-3 z-50"
        >
        <DayPicker
          mode="single"
          selected={value}
          onSelect={onChange}
          disabled={disabled}
          captionLayout="dropdown"
          startMonth={new Date(1980, 0)}
          endMonth={new Date()}
        />  
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}